<template>
  <div class="main-recommend app-container" v-loading="httpLoading">
    <h1>甄选商品</h1>
    <div class="main-recommend-content">
      <EsProductView
        v-for="(item,index) in selectionGoodss"
        :key="index + Math.random()"
        :item="item"
      />
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  import EsProductView from "@/components/product";
  import Bus from '@/util/bus'
  import {index} from "@/api/goods/goods.js";

  export default {
    name: "EsMainRecommend",
    components: { EsProductView },
    data() {
      return {
        httpLoading: false,
        floorsList:[],
        selectionGoodss: [], //甄选
      };
    },
    computed: {
      ...mapGetters("home", ["recommendList"]),
      isExistRecomend() {
        return !!this.recommendList.length;
      },
    },
    methods: {
      // ...mapActions("home", [
      //   "requestRecommendLList",
      //   "requestRecommendNewLList",
      // ]),
      // Bus.$on('cencalKeep',)
      async getList(){
        // this.recommendList = []
         try {
        this.httpLoading = true;
        // await this.requestRecommendLList({ params: { recTime: Date.now() }, type: 0 })
        // await this.requestRecommendNewLList({
        //   type: 1,
        //   pageSize: 24,
        //   pageNum: 1,
        // });
      } finally {
        this.httpLoading = false;
        this.$emit("onload");
      }
      },

      index_floor_goods: function() {
        this.loading=true;
				index(this.queryParams).then(response => {
					this.loading=false;
					// this.floorsList = response.data.data.floorGoodss;
					// this.rootGoodsCategories = response.data.data.rootGoodsCategories;
					this.selectionGoodss = response.data.data.selectionGoodss;
					// this.goodsCategorys = response.data.data.goodsCategorys;
					// this.goodsCategorysWidth = 160 * this.goodsCategorys.length;

				});
			},




    },
    async mounted() {
      
      // Bus.$on('cancelKeep', (id)=>{
      //   const i = this.recommendList.findIndex(x => x.id == id)
      //   if(i>-1){
      //     // this.$nextTick(() => {
      //       this.getList()
      //     // })
      //   }
      // })
      // Bus.$on('keepProduct', (id)=>{
      //   const i = this.recommendList.findIndex(x => x.id == id)
      //   if(i>-1){
      //     // this.$nextTick(() => {
      //       this.getList()
      //     // })
      //   }
      // })
      // this.getList()

      this.index_floor_goods();

    },
  };
</script>

<style lang="scss">
  .main-recommend {
    margin-top: 26px;
    h1 {
      font-weight: 700;
      font-size: 16px;
      color: var(--color-grey);
    }
    &-content {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(228px, 190px));
      grid-column-gap: 14px;
      grid-row-gap: 20px;
      align-content: center;
      margin-top: 15px;
    }
  }
</style>
